import { useState } from 'react';
import ModuleListLayout from '../ModuleListLayout';
import AddModuleFormWrapper from 'src/screens/Configurations/Modules/Add/AddModuleFormWrapper';
import {useParams } from 'react-router-dom';

type Props = {
  items: any;
  moduleIsLoading: any
};

const AddModule = ({ items ,moduleIsLoading }: Props) => {  

   const {moduleId} = useParams()
  const [isOpenAddFormDialog, setIsOpenAddFormDialog] = useState(false);
  const [searchValue, setSearchValue] = useState("")

  return (
    <>
      <ModuleListLayout
        listHeading='Modules'
        onAddClick={() => {
          setIsOpenAddFormDialog(true);
        }}
        listData={items}
        disabled={false}
        moduleId={moduleId || ''}
        moduleIsLoading={moduleIsLoading}
        OnSearchChange={setSearchValue}
        searchValue={searchValue}
      />
      {isOpenAddFormDialog ? (
        <AddModuleFormWrapper  onClose={() => setIsOpenAddFormDialog(false)} />
      ) : null}
    </>


  )
}

export default AddModule
